// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"29b8d740","183":"883c13f4","356":"d460bfa7","496":"e9a43956","513":"bd256d0b","546":"376e227b","590":"73565130","937":"7aad4e2a","985":"f8efb888"}[chunkId] + ".chunk.js";
};